var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.8016C13.9882 10.8016 15.6 9.18979 15.6 7.20156C15.6 5.21334 13.9882 3.60156 12 3.60156C10.0117 3.60156 8.39997 5.21334 8.39997 7.20156C8.39997 9.18979 10.0117 10.8016 12 10.8016Z",
    fill: "#419485"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59998 21.6016C3.59998 16.9624 7.36078 13.2016 12 13.2016C16.6392 13.2016 20.4 16.9624 20.4 21.6016H3.59998Z",
    fill: "#419485"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrowIcon);
export default __webpack_public_path__ + "static/media/borrow_icon.dd4c7142e53d0fb80aa99be2ef839076.svg";
export { ForwardRef as ReactComponent };